import React from 'react';
import {useIntl} from 'react-intl';
import cn from 'classnames';

import Money from 'brandComponents/Money';
import Typography from 'brandComponents/Typography';

import {IOrderDetailsSummaryProps} from './IOrderDetailsSummary';
import messages from './messages';

const OrderDetailsSummary = ({
	classNames,
	shippingCost,
	productTotal,
	orderTotal,
	currency,
}: IOrderDetailsSummaryProps) => {
	const intl = useIntl();

	return (
		<div className={cn(classNames.summary, 'order-details__summary')}>
			<Typography variant="h6" classNames="order-details__summary__title">
				{intl.formatMessage(messages.title)}
			</Typography>
			<div>
				<span>{intl.formatMessage(messages.itemSubtotal)}</span>
				<Money value={productTotal} currency={currency} showLocalizedPrices={false} />
			</div>
			<div>
				<span>{intl.formatMessage(messages.delivery)}</span>
				<Money value={shippingCost} currency={currency} showLocalizedPrices={false} />
			</div>
			<div className={cn(classNames.summaryTotal, 'order-details__summary__total')}>
				<span>{intl.formatMessage(messages.orderTotal)}</span>
				<Money value={orderTotal} currency={currency} showLocalizedPrices={false} />
			</div>
		</div>
	);
};

export default OrderDetailsSummary;
